export const protectedTheme = {
  page: "min-h-full bg-[#f6f3ea] p-4 md:rounded-3xl md:p-6",
  pagePlain: "min-h-full bg-[#f6f3ea]",
  shell: "mx-auto max-w-7xl space-y-5",
  card: "rounded-2xl bg-white p-4 shadow sm:p-5",
  cardSoft: "rounded-2xl border border-emerald-100 bg-white/90 p-4 shadow-sm",
  input:
    "w-full rounded-xl border border-zinc-200 bg-white px-3 py-2 text-sm outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100 disabled:bg-zinc-100 disabled:text-zinc-500",
  label: "block text-sm font-semibold text-zinc-700",
  helper: "text-sm text-zinc-500",
  primaryButton:
    "rounded-xl bg-emerald-700 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-emerald-800 disabled:cursor-not-allowed disabled:opacity-60",
  secondaryButton:
    "rounded-xl border border-zinc-200 bg-white px-4 py-2 text-sm font-semibold text-zinc-700 transition hover:bg-zinc-50 disabled:cursor-not-allowed disabled:opacity-60",
  accentButton:
    "rounded-xl bg-lime-300 px-4 py-2 text-sm font-black text-emerald-950 shadow transition hover:bg-lime-200 disabled:cursor-not-allowed disabled:opacity-60",
  eyebrow: "text-sm font-semibold uppercase tracking-[0.2em] text-emerald-700",
  title: "text-3xl font-black tracking-tight text-zinc-950",
};
